import Api from '@/services/Api'
import store from '@/store'
import router from '@/router'
import { ToastProgrammatic as Toast } from 'buefy'

const base = '/auth/'
const pass = 'password/'

export default {
  Login(params) {
    return Api().post(`${base}login`, {
      email: params.email,
      password: params.password
    }).then(response => {
      store.commit('login', response.data)
      router.replace({ path: '/dashboard' })
    },
      error => {
        if (error.message) {
          Toast.open({
            duration: 5000,
            message: error.message,
            position: 'is-top-right',
            type: 'is-danger'
          })
        }
        return Promise.reject(error.message)
      })
  },
  logout() {
    return Api().get(`${base}logout`).then(() => {
      store.commit('logout')
      router.replace({ name: 'login' })
    },
      error => {
        if (error.message) {
          Toast.open({
            duration: 5000,
            message: error.message,
            position: 'is-top-right',
            type: 'is-danger'
          })
        }
      })
  },

  ResetPassword(params) {
    return Api().post(`${base}${pass}reset`, {
      email: params.email,
      password: params.password,
      password_confirmation: params.password_confirmation,
      token: params.token
    }).then(response => {
      return response
    },
      error => {
        if (error.message) {
          Toast.open({
            duration: 5000,
            message: error.message,
            position: 'is-top-right',
            type: 'is-danger'
          })
        }
        return Promise.reject(error.message)
      })
  },

  RequestPassword(params) {
    return Api().post(`${base}${pass}request`, {
      email: params.email
    }).then(response => {
      return response
    },
      error => {
        if (error.message) {
          Toast.open({
            duration: 5000,
            message: error.message,
            position: 'is-top-right',
            type: 'is-danger'
          })
        }
        return Promise.reject(error.message)
      })
  },

  ValidateRequestPassword(token) {
    return Api().get(`${base}${pass}request/${token}`).then(response => response,
      error => {
        if (error.message) {
          Toast.open({
            duration: 5000,
            message: error.message,
            position: 'is-top-right',
            type: 'is-danger'
          })
        }
        return Promise.reject(error.message)
      })
  },

}
